// src/App.tsx
// אפליקציה ראשית - KipiKid

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// דפי טאבלט
import TabletLogin from './pages/tablet/TabletLogin';
import TabletDashboard from './pages/tablet/TabletDashboard';
import TabletPurchaseLists from './pages/tablet/TabletPurchaseLists';

// דפי הורים
import ParentLogin from './pages/parent/ParentLogin';
import ParentLayout from './pages/parent/Parentlayout';
import ParentDashboard from './pages/parent/ParentDashboard';
import ParentChildren from './pages/parent/ParentChildren';
import ParentCalendar from './pages/parent/ParentCalendar';
import ParentMessages from './pages/parent/ParentMessages';
import ParentSettings from './pages/parent/ParentSettings';
import ParentRegistration from './pages/parent/ParentRegistration';
import ParentContacts from './pages/parent/ParentContacts';
import AcceptInvitation from './pages/parent/AcceptInvitation';

// דפי מנהל
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminStaff from './pages/admin/AdminStaff';
import AdminChildren from './pages/admin/AdminChildren';
import AdminKindergartens from './pages/admin/AdminKindergartens';
import AdminSettings from './pages/admin/AdminSettings';
import AdminOrganizations from './pages/admin/AdminOrganizations';
import AdminProducts from './pages/admin/AdminProducts';
import AdminCategories from './pages/admin/AdminCategories';
import AdminBudgetDashboard from './pages/admin/AdminBudgetDashboard';
import AdminAttendanceHistory from './pages/admin/AdminAttendanceHistory';
import AdminCalendar from './pages/admin/AdminCalendar';
import AdminGateDevices from './pages/admin/AdminGateDevices';

// דפי מנהל מערכת
import SysAdminLogin from './pages/sysadmin/SysAdminLogin';
import SysAdminLayout from './pages/sysadmin/SysAdminLayout';
import SysAdminDashboard from './pages/sysadmin/SysAdminDashboard';
import SysAdminOrganizations from './pages/sysadmin/SysAdminOrganizations';

// דפי מוקד חרום
import CallCenterLogin from './pages/callcenter/CallCenterLogin';
import CallCenterLayout from './pages/callcenter/CallCenterLayout';
import CallCenterDashboard from './pages/callcenter/CallCenterDashboard';

// דפי גננת
import TeacherLogin from './pages/teacher/TeacherLogin';
import TeacherSelectKindergarten from './pages/teacher/TeacherSelectKindergarten';
import TeacherLayout from './pages/teacher/TeacherLayout';
import TeacherDashboard from './pages/teacher/TeacherDashboard';
import TeacherBudgets from './pages/teacher/TeacherBudgets';
import TeacherExpenses from './pages/teacher/TeacherExpenses';
import TeacherPurchaseLists from './pages/teacher/TeacherPurchaseLists';
import TeacherInvoiceCapture from './pages/teacher/TeacherInvoiceCapture';
import TeacherMessages from './pages/teacher/TeacherMessages';
import TeacherSettings from './pages/teacher/TeacherSettings';

// דפי סימולציה
import SimulationLogin from './pages/simulation/SimulationLogin';
import SimulationDashboard from './pages/simulation/SimulationDashboard';

// באנר סימולציה
import SimulationBanner from './components/SimulationBanner';

// דף אישור הסכם (משותף)
import AgreementApprovalPage from './pages/common/AgreementApprovalPage';

// דפי שיווק
import MarketingLayout from './pages/marketing/MarketingLayout';
import MarketingHome from './pages/marketing/HomePage';
import ParentsPage from './pages/marketing/ParentsPage';
import KindergartensPage from './pages/marketing/KindergartensPage';
import NetworksPage from './pages/marketing/NetworksPage';
import EmergencyPage from './pages/marketing/EmergencyPage';
import ContactPage from './pages/marketing/ContactPage';
import UnifiedLoginPage from './pages/marketing/UnifiedLoginPage';
import PrivacyPage from './pages/marketing/PrivacyPage';
import TermsPage from './pages/marketing/TermsPage';
import AccessibilityStatementPage from './pages/marketing/AccessibilityStatementPage';

function App() {
  return (
    <BrowserRouter>
      <SimulationBanner />
      <Routes>
        {/* אתר שיווקי */}
        <Route element={<MarketingLayout />}>
          <Route path="/" element={<MarketingHome />} />
          <Route path="/parents" element={<ParentsPage />} />
          <Route path="/kindergartens" element={<KindergartensPage />} />
          <Route path="/networks" element={<NetworksPage />} />
          <Route path="/emergency" element={<EmergencyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/accessibility-statement" element={<AccessibilityStatementPage />} />
          <Route path="/login" element={<UnifiedLoginPage />} />
        </Route>

        {/* אישור הסכם */}
        <Route path="/agreement-approval" element={<AgreementApprovalPage />} />

        {/* ממשק טאבלט */}
        <Route path="/tablet/login" element={<TabletLogin />} />
        <Route path="/tablet/dashboard" element={<TabletDashboard />} />
        <Route path="/tablet/purchases" element={<TabletPurchaseLists />} />

        {/* ממשק הורים */}
        <Route path="/parent/login" element={<ParentLogin />} />
        <Route path="/parent/register" element={<ParentRegistration />} />
        <Route path="/parent/register/:inviteToken" element={<ParentRegistration />} />
        <Route path="/invite/:token" element={<AcceptInvitation />} />
        <Route path="/parent" element={<ParentLayout />}>
          <Route path="dashboard" element={<ParentDashboard />} />
          <Route path="children" element={<ParentChildren />} />
          <Route path="contacts" element={<ParentContacts />} />
          <Route path="calendar" element={<ParentCalendar />} />
          <Route path="messages" element={<ParentMessages />} />
          <Route path="settings" element={<ParentSettings />} />
        </Route>

        {/* ממשק מנהל */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="organizations" element={<AdminOrganizations />} />
          <Route path="staff" element={<AdminStaff />} />
          <Route path="children" element={<AdminChildren />} />
          <Route path="attendance-history" element={<AdminAttendanceHistory />} />
          <Route path="kindergartens" element={<AdminKindergartens />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="budget" element={<AdminBudgetDashboard />} />
          <Route path="calendar" element={<AdminCalendar />} />
          <Route path="devices" element={<AdminGateDevices />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* ממשק מנהל מערכת */}
        <Route path="/sysadmin/login" element={<SysAdminLogin />} />
        <Route path="/sysadmin" element={<SysAdminLayout />}>
          <Route path="dashboard" element={<SysAdminDashboard />} />
          <Route path="organizations" element={<SysAdminOrganizations />} />
          <Route path="staff" element={<AdminStaff />} />
          <Route path="kindergartens" element={<AdminKindergartens />} />
          <Route path="children" element={<AdminChildren />} />
          <Route path="attendance-history" element={<AdminAttendanceHistory />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="calendar" element={<AdminCalendar />} />
          <Route path="devices" element={<AdminGateDevices />} />
          <Route path="settings" element={<AdminSettings />} />
        </Route>

        {/* מוקד חרום */}
        <Route path="/callcenter/login" element={<CallCenterLogin />} />
        <Route path="/callcenter" element={<CallCenterLayout />}>
          <Route path="dashboard" element={<CallCenterDashboard />} />
        </Route>

        {/* ממשק גננת */}
        <Route path="/teacher/login" element={<TeacherLogin />} />
        <Route path="/teacher/select-kindergarten" element={<TeacherSelectKindergarten />} />
        <Route path="/teacher" element={<TeacherLayout />}>
          <Route path="dashboard" element={<TeacherDashboard />} />
          <Route path="budgets" element={<TeacherBudgets />} />
          <Route path="expenses" element={<TeacherExpenses />} />
          <Route path="purchases" element={<TeacherPurchaseLists />} />
          <Route path="invoices" element={<TeacherInvoiceCapture />} />
          <Route path="messages" element={<TeacherMessages />} />
          <Route path="settings" element={<TeacherSettings />} />
        </Route>

        {/* סימולציה */}
        <Route path="/simulation/login" element={<SimulationLogin />} />
        <Route path="/simulation/dashboard" element={<SimulationDashboard />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
